import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { EmptyState } from '@/components/ui/empty-state'
import type { Person } from '@/lib/contacts/types'
import { MembershipHistory } from '@/pages/PersonMembershipHistory'

export function PersonMembershipEmpty({
  person,
  currentAssociationTimeZone,
  onAssign,
  canAssign = true,
}: {
  person: Person
  currentAssociationTimeZone?: string
  onAssign: () => void
  canAssign?: boolean
}) {
  return (
    <Card className="max-w-2xl">
      <CardContent className="divide-y divide-border p-0">
        <EmptyState
          title="Not a member"
          className="min-h-44"
          action={
            canAssign ? (
              <Button
                type="button"
                variant="outline"
                className="h-auto border-dashed px-1.5 py-0.5 text-micro"
                onClick={onAssign}
              >
                + Assign membership
              </Button>
            ) : undefined
          }
        />
        <MembershipHistory
          history={person.membership_history}
          autopayHistory={person.autopay_history ?? []}
          timeZone={currentAssociationTimeZone}
        />
      </CardContent>
    </Card>
  )
}
